import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsBaseCarousel/SdsBaseCarousel.vue.js';
import { SdsBaseCarouselSlots } from '../SdsBaseCarousel/types.js';
import { validators } from '../SdsBaseCarousel/validators.js';

function convertLayoutVariant(variant, value) {
    if (variant === 'fixed') {
        return {
            itemsPerSlide: value,
        };
    }
    return {
        itemsPerSlide: 'auto',
        itemsPerSlideAutoWidth: value,
    };
}
var script = defineComponent({
    name: 'SdsCarousel',
    props: {
        items: {
            type: Array,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        layoutVariant: {
            type: String,
            required: false,
            default: 'fixed',
        },
        layoutValue: {
            type: Number,
            required: false,
            default: 1,
            validator: function (value) {
                return validators.positiveIntegerExcluding0(value);
            },
        },
        responsiveLayoutValue: {
            type: Object,
            required: false,
            default: function () { return ({}); },
            validator: function (value) {
                return Object.keys(value).every(function (breakpoint) {
                    var breakpointValue = parseInt(breakpoint);
                    var currentValue = value[breakpointValue];
                    return validators.positiveIntegerExcluding0(currentValue);
                });
            },
        },
        customizeBaseOptions: {
            type: Object,
            required: false,
            default: function () { return ({}); },
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'slideChanged',
        'navigatorPreviousClick',
        'navigatorNextClick',
        'indicatorClick',
        'scrollPrevious',
        'scrollNext',
        'hover',
        'focusWithin',
        'itemClick',
        'itemHover',
        'itemFocusWithin',
    ],
    setup: function (props) {
        var activeLayoutVariant = computed(function () { return convertLayoutVariant(props.layoutVariant, props.layoutValue); });
        var activeResponsiveLayoutVariant = computed(function () { return Object.entries(props.responsiveLayoutValue).reduce(function (acc, _a) {
            var breakpoint = _a[0], value = _a[1];
            acc[parseInt(breakpoint)] = convertLayoutVariant(props.layoutVariant, value);
            return acc;
        }, {}); });
        var options = computed(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            return {
                showEdgeOffset: (_a = props.customizeBaseOptions.showEdgeOffset) !== null && _a !== void 0 ? _a : false,
                showEdgeEffect: (_b = props.customizeBaseOptions.showEdgeEffect) !== null && _b !== void 0 ? _b : props.layoutVariant === 'auto',
                edgeEffectVariant: (_c = props.customizeBaseOptions.edgeEffectVariant) !== null && _c !== void 0 ? _c : 'gradientBody',
                showNavigator: (_d = props.customizeBaseOptions.showNavigator) !== null && _d !== void 0 ? _d : true,
                navigatorVariant: (_e = props.customizeBaseOptions.navigatorVariant) !== null && _e !== void 0 ? _e : (props.layoutVariant === 'fixed' ? 'standalone' : 'inline'),
                showIndicator: (_f = props.customizeBaseOptions.showIndicator) !== null && _f !== void 0 ? _f : true,
                indicatorVariant: (_g = props.customizeBaseOptions.indicatorVariant) !== null && _g !== void 0 ? _g : (props.layoutVariant === 'fixed' ? 'interactive' : 'static'),
                partiallyVisibleVariant: (_h = props.customizeBaseOptions.partiallyVisibleVariant) !== null && _h !== void 0 ? _h : 'active',
                scrollSnap: (_j = props.customizeBaseOptions.scrollSnap) !== null && _j !== void 0 ? _j : true,
                expandOnlyItem: (_k = props.customizeBaseOptions.expandOnlyItem) !== null && _k !== void 0 ? _k : true,
            };
        });
        var mobileOptions = computed(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var customizeBaseMobileOptions = (_a = props.customizeBaseOptions.mobileOptions) !== null && _a !== void 0 ? _a : {};
            return {
                showEdgeOffset: (_b = customizeBaseMobileOptions.showEdgeOffset) !== null && _b !== void 0 ? _b : true,
                showEdgeEffect: (_c = customizeBaseMobileOptions.showEdgeEffect) !== null && _c !== void 0 ? _c : true,
                edgeEffectVariant: (_d = customizeBaseMobileOptions.edgeEffectVariant) !== null && _d !== void 0 ? _d : 'clip',
                showNavigator: (_e = customizeBaseMobileOptions.showNavigator) !== null && _e !== void 0 ? _e : false,
                navigatorVariant: (_f = customizeBaseMobileOptions.navigatorVariant) !== null && _f !== void 0 ? _f : 'standalone',
                showIndicator: (_g = customizeBaseMobileOptions.showIndicator) !== null && _g !== void 0 ? _g : props.layoutVariant === 'fixed',
                indicatorVariant: (_h = customizeBaseMobileOptions.indicatorVariant) !== null && _h !== void 0 ? _h : 'static',
                partiallyVisibleVariant: (_j = customizeBaseMobileOptions.partiallyVisibleVariant) !== null && _j !== void 0 ? _j : 'active',
                scrollSnap: (_k = customizeBaseMobileOptions.scrollSnap) !== null && _k !== void 0 ? _k : props.layoutVariant === 'fixed',
                expandOnlyItem: (_l = customizeBaseMobileOptions.expandOnlyItem) !== null && _l !== void 0 ? _l : true,
            };
        });
        return {
            activeLayoutVariant: activeLayoutVariant,
            activeResponsiveLayoutVariant: activeResponsiveLayoutVariant,
            SdsBaseCarouselSlots: SdsBaseCarouselSlots,
            options: options,
            mobileOptions: mobileOptions
        };
    },
    components: {
        SdsBaseCarousel: __vue_component__,
    },
});

export default script;
